import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import classes from "./InstitutionPage.module.css";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import EyeOpen from "../LoginPage/images/EyeOpen.svg";
import EyeClosed from "../LoginPage/images/EyeClosed.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useConfig} from "../../hooks/useConfig";
import {
    BUTTON,
    CSM_HOME_PATH,
    FULL_NAME_LENGTH,
    SHORT_NAME_LENGTH
} from "../../utils/constants";
import Skeleton from "react-loading-skeleton";
import {useSession} from "../../hooks/useSession";
import {ReactComponent as SAVE} from "../../images/Save.svg";
import {ReactComponent as BACK} from "../../images/back-arrow.svg";
import {ReactComponent as DELETE} from "./images/delete-icon.svg";
import {ReactComponent as STAR} from "../../images/star_red.svg";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";
import { useTranslation } from "react-i18next";

export default function InstitutionPage({setPageIdentifier}) {
    const { t } = useTranslation();
    const { instId } = useParams();
    let history = useHistory();
    let config = useConfig();
    let {getSession} = useSession();
    let {userId} = getSession();
    const {loadInstitution, listYuJaAccount, listTimeZone, saveInstitution, checkNameExited, checkDomainExited} = InstitutionApiCalls();
    let [setIsDomainUpdated, ] = useLocalStorageNew("isDomainUpdated", false);

    const [loading, setLoading] = useState(true);
    const [typeOptions, ] = useState([
        {label: t("institution.typeSchool"), value: "SCHOOL"},
        {label: t("institution.typeOrganisation"), value: "ORGANISATION"},
    ]);
    const [timeZoneOptions, setTimeZoneOption] = useState([]);
    const [accountOptions, setAccountOptions] = useState([]);
    const [institution, setInstitution] = useState({});
    const [rawInst, setRawInst] = useState({});
    const [tokenShown, setTokenShown] = useState(false);
    const [fullNameErrorMsg, setFullNameErrorMsg] = useState("");
    const [shortNameErrorMsg, setShortNameErrorMsg] = useState("");
    const [yuJaAccountIdErrorMsg, setYuJaAccountIdErrorMsg] = useState("");


    useEffect(() => {
        setPageIdentifier(!instId ? "Institution Installation" : "Institution Information");
        setLoading(true);
        let promises = [];
        promises.push(listYuJaAccount());
        promises.push(listTimeZone());

        //     .then(res => {
        //     loadData();
        //     const options = res.map(s => ({value: s, label: s}));
        //     setTimeZoneOption(options);
        // });
        if (!!instId) {
            promises.push(loadInstitution(instId));

            Promise.all(promises).then(([accounts, timeZones, inst]) => {
                const options = timeZones.map(s => ({value: s, label: s}));
                accounts = accounts.map(s => ({value: s.yujaAccountId, label: s.name}));
                setAccountOptions(accounts);
                setTimeZoneOption(options);
                setInstitution(inst);
                setRawInst(JSON.parse(JSON.stringify(inst)));
                if (!inst.shortName) {
                    setShortNameErrorMsg("Institution Identifier is required");
                }
                if (!inst.yujaAccountId) {
                    setYuJaAccountIdErrorMsg("YuJa Account is required");
                }
            }).finally(() => {
                setLoading(false);
            });
        } else {
            Promise.all(promises).then(([accounts, timeZones]) => {
                const options = timeZones.map(s => ({value: s, label: s}));
                accounts = accounts.map(s => ({value: s.yujaAccountId, label: s.name}));
                setAccountOptions(accounts);
                setTimeZoneOption(options);

                let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const filterArr = options.filter((i) => i.value.indexOf(timeZone) > -1);
                if (filterArr.length === 0) {
                    timeZone = options[0].value;
                }else {
                    timeZone = filterArr[0].value;
                }

                setInstitution({
                    type: "SCHOOL",
                    timeZone,
                    collectUserLogs: false,
                    showChromeExtensions: false,
                    evpVideoAuthToken: ""
                });

                setRawInst({});
                // setFullNameErrorMsg("Institution name is required");
                // setShortNameErrorMsg("Institution Identifier is required");
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [instId]);

    const toggleToken = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await setTokenShown(!tokenShown);
        const input = document.getElementById('input-token');
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
    }


    const isSaveBtnDisabled = () => {
        if (!!instId && JSON.stringify(rawInst) === JSON.stringify(institution)) {
            return true;
        }

        if (!institution.fullName) {
            return true;
        }

        if (!institution.shortName) {
            return true;
        }

        if (!institution.yujaAccountId) {
            return true;
        }

        if (!!fullNameErrorMsg || !!shortNameErrorMsg) {
            return true;
        }

        return false;
    }

    const isDiscardBtnDisabled = () => {
        return !!instId && JSON.stringify(rawInst) === JSON.stringify(institution);
    }

    const handleDiscard = () => {
        let copy = JSON.parse(JSON.stringify(rawInst));
        setInstitution(copy);
        if (!copy.shortName) {
            setShortNameErrorMsg("Institution Identifier is required");
        }

        if (!copy.yujaAccountId) {
            setYuJaAccountIdErrorMsg("YuJa Account is required");
        }
    }


    const handleSave = async () => {
        if (rawInst.fullName !== institution.fullName) {
            if (!institution.fullName) {
                setFullNameErrorMsg("Institution name is required");
                return;
            }

            const res = await checkNameExited({fullName: institution.fullName});
            if (res) {
                setFullNameErrorMsg("Institution Name has existed in DB");
                return;
            }
        }

        if (rawInst.shortName !== institution.shortName) {
            const dnsLabelRegex = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
            if (!institution.shortName) {
                setShortNameErrorMsg("Institution Identifier is required");
                return;
            } else if (!dnsLabelRegex.test(institution.shortName)) {
                setShortNameErrorMsg("Lower letters, digits, and hyphens only. Cannot start or end with a hyphen.");
                return;
            }

            const res = await checkNameExited({shortName: institution.shortName});
            if (res) {
                setShortNameErrorMsg("Institution Identifier already exists in DB");
                return;
            }

            let domainExisted = await checkDomainExited(institution.shortName);
            if (domainExisted === null) {
                setShortNameErrorMsg("Domain verification failed");
                return;
            } else if (!!domainExisted) {
                setShortNameErrorMsg("Domain already exists");
                return;
            }
        }

        let inst = {};
        if (!!instId) {
            inst = rawInst;
            inst.adminManagers = inst.hasOwnProperty("adminManagers") ? inst.adminManagers : "[]";
        } else {
            inst.adminManagers = JSON.stringify([{id: userId, role: "IT_MANAGER"}]);
        }
        inst.fullName = institution.fullName;
        inst.shortName = institution.shortName;
        inst.type = institution.type;
        inst.timeZone = institution.timeZone;
        inst.collectUserLogs = institution.collectUserLogs;
        inst.showChromeExtensions = institution.showChromeExtensions;
        inst.evpVideoApiUrl = institution.evpVideoApiUrl;
        inst.evpVideoAuthToken = institution.evpVideoAuthToken;
        inst.yujaAccountId = institution.yujaAccountId;

        setLoading(true);
        const res = await saveInstitution(inst, !instId);

        if (!!res) {
            setInstitution(res);
            setRawInst(JSON.parse(JSON.stringify(res)));
        }
        setLoading(false);
        if (rawInst.shortName !== inst.shortName) {
            setIsDomainUpdated(true);
        }
        history.push(CSM_HOME_PATH);
    }


    if (!!loading) {
        return (
            <div className={classes.parentContainer} style={{paddingTop: 50}}>
                <div className={classes.header}>
                    <div style={{flex: 1}}/>
                    <Skeleton borderRadius={4} height={36} inline={true} width={180}/>
                </div>

                <div className={classes.card}>
                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={50} inline={true} width={"100%"}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={35} inline={true} width={"60%"}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={35} inline={true} width={230}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={35} inline={true} width={320}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={35} inline={true} width={80}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={35} inline={true} width={80}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={50} inline={true} width={"100%"}/>

                    <Skeleton borderRadius={4} height={60} inline={true} width={`${60 + Math.random() * 30}%`}/>
                    <Skeleton borderRadius={4} height={50} inline={true} width={"100%"}/>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.parentContainer} style={{paddingTop: 50}}>
            <div className={classes.header}>
                <div
                    tabIndex={0}
                    role={BUTTON}
                    aria-label={t("institution.goBackInstitutions")}
                    style={{cursor: "pointer", fontSize: 18}}
                    onClick={() => history.push(CSM_HOME_PATH)}
                >
                    <BACK style={{marginRight: 5}}/>{t("institution.institutionsTitle")}
                </div>
                <div style={{flex: 1}}/>
                {!!instId &&
                    <YuJaButton
                        type={"delete"}
                        style={{height: 36, marginRight: 15, width: 180}}
                        disabled={isDiscardBtnDisabled()}
                        onClick={handleDiscard}
                    >
                        <DELETE style={{marginRight: 5}}/>
                        {t("poll.discardButton")}
                    </YuJaButton>
                }

                <YuJaButton
                    style={{height: 36, width: 180}}
                    disabled={isSaveBtnDisabled()}
                    onClick={handleSave}
                >
                    <SAVE style={{marginRight: 5}}/>
                    {!!instId ? t("institution.saveChangesText") : t("institution.installInstitution")}
                </YuJaButton>
            </div>
            <div className={classes.card}>
                {/*Institution Name*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label} style={{alignItems: "center", gap: 3}}>
                        {t("institution.csmInstitutionTableNameHeader")} <STAR/>
                    </div>
                    <div className={classes.description}>{t("institution.nameDesc")}</div>
                </div>


                <YuJaTextBox
                    containerStyle={{height: 40, fontSize: 15}}
                    placeholder={t("institution.csmInstitutionTableNameHeader")}
                    maxLength={FULL_NAME_LENGTH}
                    value={institution.fullName || ""}
                    onChange={(event) => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.fullName = event.target.value;
                        setInstitution(copy);
                    }}
                    onBlur={() => {
                        if (!institution.fullName) {
                            setFullNameErrorMsg("Institution name is required");
                        } else {
                            setFullNameErrorMsg("");
                        }
                    }}
                    isInvalid={!!fullNameErrorMsg}
                    limitedSpace={false}
                    errorMsg={fullNameErrorMsg}
                />


                {/*Domain*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label} style={{alignItems: "center", gap: 3}}>{t("integration.domainLabel")} <STAR/></div>
                    <div className={classes.description}>{t("institution.baseUrlDesc")}</div>
                </div>

                <div className={classes.row} style={{gap: 5, alignItems: "baseline"}}>
                    <YuJaTextBox
                        containerStyle={{height: 35, fontSize: 15, maxWidth: 230}}
                        placeholder={t("institution.identifierPlaceholder")}
                        value={institution.shortName || ""}
                        maxLength={SHORT_NAME_LENGTH}
                        onChange={(event) => {
                            let copy = JSON.parse(JSON.stringify(institution));
                            copy.shortName = event.target.value;
                            setInstitution(copy);
                        }}
                        onBlur={() => {
                            const dnsLabelRegex = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
                            if (!institution.shortName) {
                                setShortNameErrorMsg("Institution Identifier is required");
                            } else if (!dnsLabelRegex.test(institution.shortName)) {
                                setShortNameErrorMsg("Lower letters, digits, and hyphens only. Cannot start or end with a hyphen.");
                            } else {
                                setShortNameErrorMsg("");
                            }
                        }}
                        isInvalid={!!shortNameErrorMsg}
                        limitedSpace={false}
                        errorMsg={shortNameErrorMsg}
                    />
                    <span>.{config.host_url}</span>
                </div>


                {/*YuJa Account*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label} style={{alignItems: "center", gap: 3}}>
                        {t("institution.yujaAccount")} <STAR/>
                    </div>
                    <div className={classes.description}>{t("institution.yujaAccountDesc")}</div>
                </div>

                <YuJaDropdown
                    data={accountOptions}
                    value={institution.yujaAccountId}
                    placeholder={t("institution.selectYujaAccount")}
                    containerStyle={{maxWidth: 300}}
                    size={"small"}
                    searchAble={true}
                    isInvalid={!!yuJaAccountIdErrorMsg}
                    errorMsg={yuJaAccountIdErrorMsg}
                    limitedSpace={false}
                    onChange={item => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.yujaAccountId = item.value;
                        setInstitution(copy);
                        if (!!copy.yujaAccountId) {
                            setYuJaAccountIdErrorMsg("");
                        } else {
                            setYuJaAccountIdErrorMsg("YuJa Account is required");
                        }
                    }}
                />


                {/*Institution Type*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>{t("institution.institutionType")}</div>
                    <div className={classes.description}>{t("institution.institutionTypeDesc")}</div>
                </div>

                <YuJaDropdown
                    data={typeOptions}
                    value={institution.type}
                    containerStyle={{maxWidth: 300}}
                    placeholder={t("institution.selectInstitutionType")}
                    size={"small"}
                    onChange={item => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.type = item.value;
                        setInstitution(copy);
                    }}
                />

                {/*Time Zone*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>{t("institution.timeZone")}</div>
                    <div className={classes.description}>{t("institution.timeZoneDesc")}</div>
                </div>

                <YuJaDropdown
                    data={timeZoneOptions}
                    value={institution.timeZone}
                    containerStyle={{maxWidth: 300}}
                    placeholder={t("institution.selectTimeZone")}
                    size={"small"}
                    onChange={item => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.timeZone = item.value;
                        setInstitution(copy);
                    }}
                />

                {/*Collect user log*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>{t("institution.collectUserLogs")}</div>
                    <div className={classes.description}>{t("institution.collectUserLogsDesc")}</div>
                </div>

                <YuJaSwitch
                    aria-label={t("institution.collectUserLogs")}
                    checked={institution.collectUserLogs || false}
                    onChange={checked => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.collectUserLogs = checked;
                        setInstitution(copy);
                    }}
                />

                {/*<YuJaToggle*/}
                {/*    name="collectUserLogs"*/}
                {/*    toggled={institution.collectUserLogs || false}*/}
                {/*    onClick={() => {*/}
                {/*        let copy = JSON.parse(JSON.stringify(institution));*/}
                {/*        copy.collectUserLogs = !copy.collectUserLogs;*/}
                {/*        setInstitution(copy);*/}
                {/*    }}*/}
                {/*/>*/}

                {/*Show Chrome Extensions*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>{t("institution.showChromeExtensions")}</div>
                    <div className={classes.description}>{t("institution.showChromeExtensionsDesc")}</div>
                </div>

                <YuJaSwitch
                    aria-label={t("institution.showChromeExtensions")}
                    checked={institution.showChromeExtensions || false}
                    onChange={checked => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.showChromeExtensions = checked;
                        setInstitution(copy);
                    }}
                />

                {/*<YuJaToggle*/}
                {/*    name="collectUserLogs"*/}
                {/*    toggled={institution.showChromeExtensions || false}*/}
                {/*    onClick={() => {*/}
                {/*        let copy = JSON.parse(JSON.stringify(institution));*/}
                {/*        copy.showChromeExtensions = !copy.showChromeExtensions;*/}
                {/*        setInstitution(copy);*/}
                {/*    }}*/}
                {/*/>*/}


                {/*Lumina Video Api URL*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>{t("institution.luminaApiUrl")}</div>
                    <div className={classes.description}>{t("institution.luminaApiUrlDesc")}</div>
                </div>

                <YuJaTextBox
                    containerStyle={{height: 40, fontSize: 15}}
                    placeholder={t("institution.luminaApiUrlPlaceholder")}
                    value={institution.evpVideoApiUrl || ""}
                    onChange={(event) => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.evpVideoApiUrl = event.target.value;
                        setInstitution(copy);
                    }}
                />

                {/*Lumina Video Api token*/}
                <div className={classes.column} style={{gap: 2}}>
                    <div className={classes.label}>{t("institution.luminaAccessToken")}</div>
                    <div className={classes.description}>{t("institution.luminaAccessTokenDesc")}</div>
                </div>

                <YuJaTextBox
                    id="input-token"
                    autocomplete="new-password"
                    type={tokenShown ? "text" : "password"}
                    containerStyle={{height: 40, fontSize: 15}}
                    placeholder={t("institution.luminaAccessTokenPlaceholder")}
                    value={institution.evpVideoAuthToken || ""}
                    after={
                        <>
                            {!!institution.evpVideoAuthToken && (
                                <img
                                    onClick={toggleToken}
                                    src={tokenShown ? EyeOpen : EyeClosed}
                                    alt="eye"
                                    style={{cursor: "pointer"}}
                                />
                            )}
                        </>
                    }
                    onChange={(event) => {
                        let copy = JSON.parse(JSON.stringify(institution));
                        copy.evpVideoAuthToken = event.target.value;
                        setInstitution(copy);
                    }}
                />
            </div>
        </div>
    );
}